<template>
    <div class="AIInterlocutor-right">
        <div v-if="!sessionId" class="init">
            <div class="" style="width: 60%;">
                <div class="flex-row">
                    <div class="flex-row" style="flex-shrink: 0;">
                        <img src="@/assets/logo.png" width="62" height="62" />
                    </div>
                    <div class="title_line t-m-l-17 " style="flex: 1;">
                        <p class="clip-reveal-text"> <span>Hi，我是全民作家AI小助手</span>
                        </p>
                        <!-- <p>由DeepSeek Al 大模型提供灵感支持,</p> -->
                        <!-- <p></p> -->
                    </div>
                </div>
                <div class="flex-row"
                    style="justify-content: space-between;margin-bottom: 4.74%;margin-top: 2.53%;gap: 18px;">
                    <p v-for="(item, index) in iconList" :key="index"
                        style="display: flex;position: relative;align-items: center;justify-content: flex-end;">
                        <img :src="item.img" width="100%" height="100%" style="display: block;object-fit: cover;" />
                        <span
                            style="position: absolute;right: 10px;font-size:16px; color: #000000;font-weight: bold;font-family: Microsoft YaHei;">{{
                                item.title }}</span>
                    </p>
                </div>
                <AIAnswerInput :streamStatus="streamStatus" ref="aiAnswerInput"></AIAnswerInput>
            </div>
        </div>
        <div v-else class="answer">
            <div class="flex-coloum flex-1" style="width: 60%;overflow: auto;">
                <div class="answer_list" ref="aiAnwser">
                    <div v-for="(item, i) in list" :key="i" style="flex: 1;display: flex;flex-direction: column;">
                        <!-- 用户区域 -->
                        <div class="user_right item">
                            <p v-if="item.file" class="t-m-b-10">
                                <file-upload :file="item.file" file-loading update-loading :update-error="false"
                                    :isShow="false" />
                            </p>
                            <p class="text">
                                {{ item.question }}
                            </p>
                            <div class="tool">
                                <p><el-tooltip content="复制" placement="top">
                                        <span class="el-icon-document-copy cursor_1"
                                            @click="copyClick(item.question)"></span>
                                    </el-tooltip>
                                </p>
                            </div>
                        </div>
                        <!-- AI回答区域 -->
                        <div class="ai_left item">
                            <p class="min-logo"><img src="@/assets/logo.png" width="28" height="28" /></p>
                            <div class="text">
                                <MarkdownRenderer v-if="item.answer" :content="item.answer"></MarkdownRenderer>
                                <p v-if="!item.answer"><img src="@/assets/image/ai_wenda/icon1.png" width="16"
                                        height="16" /><span class="title">全民作家AI问答思考中</span></p>
                            </div>
                            <div class="tool">
                                <p v-if="item.id"><el-tooltip content="复制" placement="top">
                                        <span class="el-icon-document-copy cursor_1"
                                            @click="copyClick(item.answer)"></span>
                                    </el-tooltip>
                                </p>
                                <p v-if="!item.id && item.curId">
                                    <el-tooltip content="复制" placement="top">
                                        <span class="el-icon-document-copy cursor_1"
                                            @click="copyClick(item.answer)"></span>
                                    </el-tooltip>
                                </p>
                                <!-- <p>
                                    <el-tooltip content="重新生成" placement="top">
                                        <span class="el-icon-refresh  cursor_1" v-show="!streamStatus && item.answer"
                                            @click="refreshClick(item, i)"></span>
                                    </el-tooltip>
                                </p> -->

                            </div>
                        </div>
                    </div>
                </div>
                <div style="flex-shrink: 0;">
                    <AIAnswerInput :status="streamStatus" ref="aiAnswerInput"></AIAnswerInput>
                </div>
            </div>
        </div>
        <div class="remind">内容由 AI 生成，仅供参考</div>
    </div>
</template>
<script>
import { EventBus } from '@/utils/eventBus'
import AnApi from '@/api/answer.js'
import api from '@/api/api.js'
import { copy } from '@/utils/utils'
import MarkdownRenderer from '@/components/global/MarkdownRenderer.vue'
import AIAnswerInput from '@/components/dongeb/AIAnswerInput.vue';
import FileUpload from '@/components/dongeb/‌FileUpload.vue'
export default {
    components: {
        AIAnswerInput, MarkdownRenderer, FileUpload
    },
    data() {
        return {
            type: 'init',
            list: [],//详情
            sessionId: '',
            streamLast: false,
            streamStatus: false, // 流式请求 false请求结束 true请求
            streamIndex: 0, // 流式请求下标
            curIndex: 0,
            iconList: [
                {
                    img: require('@/assets/image/ai_wenda/1.png'),
                    title: '全民作家大模型升级'
                },
                {
                    img: require('@/assets/image/ai_wenda/2.png'),
                    title: '支持更长上下文'
                },
                {
                    img: require('@/assets/image/ai_wenda/3.png'),
                    title: '更强的理解能力'
                },
                {
                    img: require('@/assets/image/ai_wenda/4.png'),
                    title: '轻松搭大纲 做设定'
                },
            ]
        }
    },
    mounted() {
        //从缓存里获取
        this.sessionId = sessionStorage.getItem(this.sessionIdKey)
        if (this.sessionId) {
            // this.type = 'answer'
            this.answerDetail(this.sessionId)
            EventBus.$emit('updateList', this.sessionId)
        }
        //监听发送
        EventBus.$on('send', (item) => {
            // this.type = 'answer'
            //访问记录详情
            if (item.id) {
                if (this.$refs.aiAnswerInput) {
                    this.$refs.aiAnswerInput.textarea = ''
                }

                this.answerDetail(item.id)
            } else {
                let data = {
                    question: item.text,
                    search: true,
                }
                if (item.fileId) {
                    data.fileId = item.fileId
                    data.file = item.file
                }
                if (this.sessionId) {
                    data.sessionId = this.sessionId
                    this.answerSendText(data, 'init')
                } else {
                    this.aiCreate(data)
                }

            }
        })
        //监听取消生成
        EventBus.$on('stop', (item = {}) => {
            let id = localStorage.getItem('AICreateId')
            this.list[item.curIndex].curId = item.curId
            api.aiStop({ logId: id }).then(res => {
                if (res.code === 200) {
                    localStorage.removeItem('AICreateId')
                    this.$message.success('已取消AI生成');
                    this.clearTimer()
                } else {
                    this.$message.warning(res.msg)
                }
            })
        })
        //监听左侧删除
        // EventBus.$on('del', () => {
        //     this.type = 'init'
        //     sessionStorage.removeItem(this.sessionIdKey)
        //     this.sessionId = ''
        //     this.curIndex = 0
        //     this.list = []
        //     this.clearTimer()
        // })
        EventBus.$on('newCreate', () => {
            // this.type = 'init'
            sessionStorage.removeItem(this.sessionIdKey)
            this.sessionId = ''
            this.curIndex = 0
            this.list = []
            this.clearTimer()
        })
    },
    beforeDestroy() {
        EventBus.$off('send')
        EventBus.$off('stop')
        // EventBus.$off('del')
        EventBus.$off('newCreate')
        sessionStorage.removeItem(this.sessionIdKey)
        this.clearTimer()
    },
    methods: {
        clearTimer(status) {
            console.log('销毁定时器')
            clearTimeout(this.debounceTimer)
            clearInterval(this.typingTimer)
            this.streamIndex = 0
            this.streamStatus = false;
            this.streamLast = false;
        },
        //复制
        async copyClick(text) {
            const success = await copy(this.stripHtmlTags(text));
            if (success) {
                this.$message.success('复制成功');
            } else {
                this.$message.error('复制失败');
            }
        },
        //重新生成
        refreshClick(item, i) {
            this.sessionId = item.sessionId
            this.curIndex = i
            sessionStorage.setItem(this.sessionIdKey, this.sessionId)
            let data = {
                sessionId: item.sessionId,
                question: item.question,
                search: true
            }
            this.list[this.curIndex].answer = ''
            //ai对话
            this.answerSendText(data, 'refresh')
        },
        //获取会话详情
        answerDetail(id) {
            AnApi.answerDetail({ sessionId: id }).then(res => {
                if (res.code === 200) {
                    this.list = res.data && res.data.filter(item => {
                        if (item.file) {
                            item.file = JSON.parse(item.file)
                        }
                        return item
                    }).reverse()
                    this.sessionId = this.list.length > 0 && this.list[0].sessionId
                    sessionStorage.setItem(this.sessionIdKey, this.sessionId)
                    this.scrollerBottom()
                }
            })
        },
        //创建会话
        aiCreate(data) {
            AnApi.answerCreate().then((res) => {
                if (res.code == 200 && res.data) {
                    this.sessionId = res.data
                    sessionStorage.setItem(this.sessionIdKey, this.sessionId)
                    data.sessionId = res.data
                    this.answerSendText(data, 'init')
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        //发送消息-对话
        answerSendText(params, type) {
            if (type == 'init') {
                this.list.push({ question: params.question, answer: '', sessionId: params.sessionId, curId: '', file: params.file })
                this.curIndex = this.list.length - 1
            }
            this.scrollerBottom()
            AnApi.answerSendText(params).then(res => {
                if (res.code === 200) {
                    if (type == 'init') {
                        EventBus.$emit('curTask', { curIndex: this.curIndex, curId: res.data })
                    }
                    EventBus.$emit('updateList', this.sessionId)
                    this.streamStatus = true
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer)
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length
                            let combinedText = ''
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item
                                }
                            })
                            if (combinedText.includes('[ERROR]')) {
                                console.log('敏感词')
                                //内容出现错误
                                this.list[this.curIndex].answer = combinedText
                                this.list[this.curIndex].curId = id
                                this.clearTimer()
                                return
                            }
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0
                                    this.streamLast = true
                                }
                                if (this.streamLast) {
                                    this.list[this.curIndex].curId = id
                                    this.clearTimer();
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                } else {
                                    this.getStreamContent(id);
                                }
                            })
                        } else {
                            this.getStreamContent(id)
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTimer()
                    }
                }).catch(() => {
                    this.clearTimer()
                })
            }, 500)
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0
            if (this.typingTimer) {
                clearInterval(this.typingTimer)
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    this.list[this.curIndex].answer += text[index]
                    // this.answerText += text[index]
                    index++
                    this.scrollerBottom()
                } else {
                    clearInterval(this.typingTimer)
                    if (callback) {
                        callback()
                    }
                }
            }, 20)
        },
        //滚动到底部
        scrollerBottom() {
            this.$nextTick(() => {
                const container = this.$refs.aiAnwser;
                if (container) {
                    container.scrollTop = container.scrollHeight; // 直接滚动到底部
                }
            });
        }
    }

}
</script>
<style lang="scss" scoped>
p {
    margin: 0;
    padding: 0;
}

.AIInterlocutor-right {
    flex: 1;
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    /* 底部预留20px空间 */
    // padding-bottom: 30px;
    box-sizing: border-box;
}

.init {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;

    .title_line {
        p:first-child {
            font-family: Microsoft YaHei;
            font-weight: bold;
            font-size: 24px;
            line-height: 1;
            color: #000000;
        }

        // p:last-child {
        //     margin-top: 12px;
        //     font-family: Microsoft YaHei;
        //     font-weight: 400;
        //     font-size: 16px;
        //     line-height: 1;
        //     color: #777777;
        // }
    }
}

.answer {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 2rem 0 0;
    overflow: auto;

    .answer_list {
        flex: 1;
        display: flex;
        flex-direction: column;
        position: relative;
        overflow: auto;
        @include no_scrollbar();

        .item:first-child {
            margin-top: 0 !important;
        }

        .item {
            margin-top: 20px;
        }

        .user_right {
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            // margin-bottom: 16px;
            position: relative;
            overflow-y: hidden;

            // &:hover{
            //     .tool{
            //         opacity: 1;
            //     }
            // }
            .text {
                font-size: 16px;
                line-height: 28px;
                color: #000;

                padding: calc((44px - 28px) / 2) 20px;
                box-sizing: border-box;
                white-space: pre-wrap;
                word-break: break-word;
                background: var(--tech-bg);
                border-radius: 25px 0px 25px 25px;
                max-width: calc(100% - 48px);
                position: relative;
            }

            .tool {
                opacity: 1;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-top: 12px;
                height: 20px;
                margin-bottom: 20px;
                gap: 20px;
                margin-right: 10px;
                transition: all 0.3s;

                .el-icon-document-copy,
                .el-icon-refresh {
                    font-size: 20px;
                    color: #909090;
                    /* 设置你想要的尺寸 */
                }
            }
        }

        .ai_left {
            font-size: 14PX;
            color: #000;
            padding-left: 48px;
            position: relative;

            .min-logo {
                position: absolute;
                top: -2px;
                left: 0;
                background-color: #fff;
                border-radius: 50%;
                justify-content: center;
                align-items: center;
                width: 28px;
                height: 28px;
                display: flex;
                box-shadow: 0 0 0 1px #d5e4ff;
            }

            .text {
                p {
                    img {
                        animation: rotate 1s linear infinite;
                    }

                    span {
                        margin-left: 5px;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #000000;
                        line-height: 30px;
                        background: linear-gradient(0deg, #059DFF 0%, #006DFF 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                }
            }

            .tool {
                display: flex;
                align-items: center;
                margin-top: 12px;
                height: 20px;
                margin-bottom: 20px;
                gap: 20px;

                .el-icon-document-copy,
                .el-icon-refresh {
                    font-size: 20px;
                    color: #909090;
                    /* 设置你想要的尺寸 */
                }
            }
        }
    }

}

::v-deep(.markdown-content) {
    font-size: 16px;

    p {
        margin: 0;
        padding: 0;
        line-height: 1.5;
    }
}

/* 定义旋转动画 */
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.remind {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a3a3a3;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
@keyframes clipReveal {
    from {
        clip-path: inset(0 100% 0 0);
    }

    to {
        clip-path: inset(0 0 0 0);
    }
}

.clip-reveal-text {
    display: inline-block;
    animation: clipReveal 0.5s ease-out forwards;
}
</style>